import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type GlobeIconProps = CommonSvgProps

const GlobeIcon: React.FC<GlobeIconProps> = React.forwardRef<SVGSVGElement, GlobeIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 72 73" {...props} ref={ref} color="none">
      <path
        d="M46 66V52.6667C46 50.8986 46.7024 49.2029 47.9526 47.9526C49.2029 46.7024 50.8986 46 52.6667 46H66"
        stroke="#51565C"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.0872 68.8877C4.88719 62.0877 1.42052 43.0543 3.08719 34.3877C7.48721 28.3877 15.2538 33.5543 18.5872 36.8877C18.5872 46.4877 22.5872 48.5543 24.5872 48.3877C32.1872 47.9877 33.0872 53.5543 32.5872 56.3877L31.5872 67.8877C43.0872 71.0543 59.2872 75.6877 32.0872 68.8877Z"
        fill="#7BB835"
      />
      <path
        d="M19.3334 9.3335V16.0002C20.0524 18.0451 21.4165 19.801 23.2201 21.0034C25.0237 22.2058 27.1692 22.7896 29.3334 22.6668V22.6668C31.1015 22.6668 32.7972 23.3692 34.0474 24.6195C35.2977 25.8697 36 27.5654 36 29.3335C36 31.1016 36.7024 32.7973 37.9527 34.0475C39.2029 35.2978 40.8986 36.0002 42.6667 36.0002C44.4348 36.0002 46.1305 35.2978 47.3808 34.0475C48.631 32.7973 49.3334 31.1016 49.3334 29.3335C49.3334 27.5654 50.0358 25.8697 51.286 24.6195C52.5362 23.3692 54.2319 22.6668 56 22.6668H66"
        stroke="#53A2D9"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 32.6665H12.6667C14.4348 32.6665 16.1305 33.3689 17.3807 34.6191C18.631 35.8694 19.3333 37.5651 19.3333 39.3332V42.6665C19.3333 44.4346 20.0357 46.1303 21.286 47.3805C22.5362 48.6308 24.2319 49.3332 26 49.3332C27.7681 49.3332 29.4638 50.0356 30.714 51.2858C31.9643 52.536 32.6667 54.2317 32.6667 55.9998V69.3332"
        stroke="#51565C"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 69.3332C54.4095 69.3332 69.3333 54.4093 69.3333 35.9998C69.3333 17.5903 54.4095 2.6665 36 2.6665C17.5905 2.6665 2.66663 17.5903 2.66663 35.9998C2.66663 54.4093 17.5905 69.3332 36 69.3332Z"
        stroke="#51565C"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
)

GlobeIcon.propTypes = commonPropTypes
GlobeIcon.defaultProps = commonDefaultProps

export default GlobeIcon
